module.exports = __webpack_public_path__ + "a38610642be9ce65e5cf58cc5ec00e4f.jpg";